// extracted by mini-css-extract-plugin
module.exports = {"buttonLabel":"_2nS5x"};